module.exports = __webpack_public_path__ + "static/media/next.0abeaa99.svg";